<template>
  <div>
    <el-dialog
      title="同步企微部门"
      :visible.sync="dialogVisible"
      width="width"
      :before-close="dialogBeforeClose"
    >
      <div>
        <!-- <div class="m-b-20">
          <el-input
            v-model="params.name"
            placeholder="请输入部门名称"
            class="input-m m-r-6"
          />
          <el-button @click="getTreeData" type="primary">
            搜索
          </el-button>
        </div> -->
        <el-tree
          ref="tree"
          :data="treeData"
          show-checkbox
          node-key="id"
          default-expand-all
          :props="defaultProps"
        />
      </div>
      <div slot="footer">
        <el-button @click="dialogBeforeClose">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="submitDepartment"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SpDepartmentSelect',
  model: {
    prop: 'dialogVisible',
    event: 'dialogVisibleChange'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      defaultProps: {
        children: 'subset',
        label: 'name'
      },
      treeData: [],
      params: {
        name: ''
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.params.name = ''
        this.getTreeData()
      }
    }
  },
  methods: {
    async getTreeData () {
      const data = await this.$api.organization.getWechatDepartment(this.params)
      if (data) {
        this.treeData = data
      }
    },
    dialogBeforeClose () {
      this.$emit('dialogVisibleChange', false)
    },
    submitDepartment () {
      let selectedTreeNode = this.$refs.tree.getCheckedNodes(false, false)
      let ids = this.resetData(selectedTreeNode)
      this.$emit('submitDepartment', ids)
    },
    resetData (node) {
      let selectIds = []
      node.forEach((v) => {
        let flag = false
        node.forEach((j) => {
          if (v.parentid === j.id) {
            flag = true
          }
        })
        if (!flag) {
          selectIds.push(v.id)
        }
      })
      return selectIds
    }
  }
}
</script>

<style lang="scss" scoped>
.m-b-20 {
  margin-bottom: 20px;
}
</style>
